var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_thumbs-up_svg__a{fill:none;stroke:#575757;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_thumbs-up_svg__a",
    d: "M14.327 24.667a5.126 5.126 0 011.357.2l3.164.923a5.125 5.125 0 001.434.205h4.254a5.266 5.266 0 005.2-4.8l.258-4.533a3.99 3.99 0 00-2.96-4.084l-1.27-.278a1.328 1.328 0 01-.992-1.294V8a1.96 1.96 0 10-3.918 0v1.381a6.6 6.6 0 01-6.53 6.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon_thumbs-up_svg__a",
    d: "M10 13.02h4.326V26H10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })));
}
export default SvgIconThumbsUp;